import { animate, scroll } from 'motion';

const SimpleHeader = () => {
  const els = document.querySelectorAll('.simple-header');

  if (els.length) {
    els.forEach((el) => {
      scroll(animate(el, { opacity: [0, 1, 1, 0], y: [0, 0, 0, 100] }), {
        target: el,
        offset: ['start end', 'end end', 'start start', 'end start'],
      });
    });
  }
};

export default SimpleHeader;
